module.exports = __webpack_public_path__ + "img/72.e3d60208.jpg";